import { MerchantNotificationsEventNamesType } from 'config/requests/merchants';
import { MerchantsShowNotificationsFormValues } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/components/MerchantsShowNotificationsForm/MerchantsShowNotificationsForm';

export const getMerchantNotificationData = (
  formValues: MerchantsShowNotificationsFormValues,
  merchantId: string,
  eventNames?: MerchantNotificationsEventNamesType[],
) => {
  const { active, chatId, event, comment, provider } = formValues;

  const currentEvents = Object.entries(event)
    .filter(([, value]) => Boolean(value))
    .map(([event]) => event);
  const events =
    !!currentEvents.length && !!eventNames?.length
      ? currentEvents?.map((eventName) => {
          const currentEvent = eventNames.find(({ name }) => eventName === name);
          return { name: `/admin/merchant_notification_event_names/${currentEvent?.value}` };
        })
      : [];

  return {
    merchant: merchantId,
    active,
    provider,
    comment: comment || '',
    notificationTransport: '/admin/notification_transports/reddy',
    credentials: {
      chatId: Number(chatId),
    },
    events,
  };
};
